import { template as template_f02bc93e02c5497bb588133f931c070e } from "@ember/template-compiler";
import { CLIENT_PORTAL_PAGES } from 'client-portal/services/client-portal-tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import Form from '../billing/insurance/form';
export default class SiteDocumentsInsuranceInfoForm extends Component {
    @service
    currentPractice;
    @service
    store;
    @tracked
    isSubmitted = false;
    @tracked
    insuranceInfoRequestConnection = null;
    constructor(){
        super(...arguments);
        this.createInsuranceInfoRequestConnection();
    }
    createInsuranceInfoRequestConnection() {
        let client = this.args.currentClient;
        let newInsuranceInfoRequestConnection = this.store.createRecord('insurance-info-request-connection', {
            client,
            insuredRelation: '0',
            isDirty: false,
            documentRequestInsuranceInfo: this.args.model
        });
        this.insuranceInfoRequestConnection = newInsuranceInfoRequestConnection;
    }
    @action
    async setSubmitted() {
        this.isSubmitted = true;
        await this.args.completeRequestTask.perform(this.args.model);
    }
    static{
        template_f02bc93e02c5497bb588133f931c070e(`
    <Form
      @client={{@currentClient}}
      @clientPortalPage={{CLIENT_PORTAL_PAGES.DOCUMENTS}}
      @insuranceInfoRequestConnection={{this.insuranceInfoRequestConnection}}
      @displayOnly={{@model.isReview}}
      @setSubmitted={{this.setSubmitted}}
      @transitionAfterSubmit={{false}}
    />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
